import { Box, Stack } from "@chakra-ui/react";
import Head from "next/head";
import { Span } from "src/components/base";
import { ArrowLink } from "src/components/base/arrow-link";
import { ModulePrimaryHeadline } from "src/components/common/module-headlines";
import { IWfAccordionItem, WfAccordion } from "src/components-mui/base/wf-accordion/wf-accordion";
import { Container } from "src/components-mui/layout/container";
import { ILabelValue, ILink } from "src/types/common";

// https://developers.google.com/search/docs/data-types/faqpage?hl=en
const structuredData = (questionAnswers: ILabelValue[]) => ({
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: questionAnswers.map(q => ({
        "@type": "Question",
        name: q.label,
        acceptedAnswer: {
            "@type": "Answer",
            text: q.value,
        },
    })),
});

export interface IFaqModuleProps {
    title: string;
    useSmallDesktopBigTitle?: boolean;
    questionAnswers: IWfAccordionItem[];
    link?: ILink;
}

export const FaqModule = ({ title, questionAnswers, link, useSmallDesktopBigTitle }: IFaqModuleProps) => (
    <Container>
        <Head>
            <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }} />
        </Head>
        <Stack direction={["column", "column", "column", "row"]} spacing={5} justify="space-between">
            <ModulePrimaryHeadline w={["100%", "100%", "100%", "323px"]} textAlign={["left", "center", "center", "left"]} pt={[0, 0, 0, 2]}>
                <Span
                    display={useSmallDesktopBigTitle ? ["block"] : undefined}
                    lineHeight={useSmallDesktopBigTitle ? ["inherit", "inherit", "inherit", 1.5] : undefined}
                    fontSize={useSmallDesktopBigTitle ? ["inherit", "inherit", "inherit", "2xl"] : undefined}
                >
                    {title}
                </Span>
            </ModulePrimaryHeadline>
            <WfAccordion
                allowMultiple
                shouldScrollIntoView
                data={questionAnswers}
                variant="large"
                sx={{ width: ["100%", "100%", "100%", "680px"] }}
            />
        </Stack>
        {link && (
            <Box mt={[4, 5, 6]} textAlign="right">
                <ArrowLink href={link.url} target={link.target} colorScheme="green">
                    {link.name}
                </ArrowLink>
            </Box>
        )}
    </Container>
);
